// src/frontend/.../Recruitment/Validation/section5.js
import errorTrackerV2 from "./Utils/ErrorTrackerV2";

const isEmpty = (v) =>
  v === null || v === undefined || (typeof v === "string" && v.trim() === "");

export function validateSection5(data = {}) {
  const formData = data || {};
  const errors = {};

  // console.log("Section 5 Validation - formData:", formData);

  // If data is null, all required fields are missing
  if (data === null || data === undefined) {
    errors["dataNotFound"] =
      "No data found for this section. Please open and save it first.";
    errorTrackerV2.setSectionErrors("section5", errors);
    // console.log("Section 5 Validation - No data found");
    return errors;
  }

  // hasAccountant required (null/undefined)
  if (formData.hasAccountant === null || formData.hasAccountant === undefined) {
    errors.hasAccountant = "This field is required";
  }

  // If hasAccountant === true -> validate accountant fields
  if (formData.hasAccountant === true) {
    if (isEmpty(formData.title)) errors.title = "This field is required";
    if (isEmpty(formData.surname)) errors.surname = "This field is required";
    if (isEmpty(formData.initials)) errors.initials = "This field is required";
    if (isEmpty(formData.telephone)) {
      errors.telephone = "This field is required";
    }
    if (isEmpty(formData.emailAddress))
      errors.emailAddress = "This field is required";
    if (isEmpty(formData.address)) errors.address = "This field is required";
    if (!formData.from) errors.from = "This field is required";
  }

  // Personal referees rule:
  // Only validate if at least one field is filled
  const personalReferees = Array.isArray(formData.personalReferees)
    ? formData.personalReferees
    : [];

  const isAnyPersonalFieldFilled = personalReferees.some((ref) =>
    Object.values(ref || {}).some((v) => !isEmpty(String(v ?? ""))),
  );

  if (isAnyPersonalFieldFilled) {
    personalReferees.forEach((referee, index) => {
      // Only validate fields that are part of the referee object structure
      const requiredFields = [
        "refereeName",
        "refereeAddress",
        "refereePhoneNumber",
        "datesOfUnemployment",
        "refereeEmailAddress",
        "relationshipToReferee",
      ];

      requiredFields.forEach((field) => {
        if (isEmpty(referee?.[field])) {
          errors[`${field}_${index}_personalReferees`] =
            "This field is required";
        }
      });
    });
  }

  // console.log("Section 5 Validation - Errors:", errors);
  // console.log(
  //   "Section 5 Validation - Is Valid:",
  //   Object.keys(errors).length === 0,
  // );

  // Set errors in tracker
  errorTrackerV2.setSectionErrors("section5", errors);

  return {
    ...errors,
    _isValid: Object.keys(errors).length === 0,
  };
}

